import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';

import { AppProvider } from './app.provider';
import { TokenProvider } from '../token/token.provider';
import { NavigationProvider } from './navigation.provider';
import { FeatureProvider } from './feature.provider';
import { UserInfoService } from './user-info.service';
import { ShellDomainProvider } from "../utility/shell-domain.provider"
import { FeatureCanActivate } from './feature.guard';
import { isPlatformBrowser } from '@angular/common';
import { UtilityService } from '../utility/utility.service';
import { ClientMonitoringService } from '../client-monitoring/client-monitoring.service';
import { ActivateLoginLinkPayload, ResetPasswordTwoFaPayload, Verify2FaForResetPasswordPayload } from './auth.interface';
import { EcapCookieService } from '../cookie/ecap-cookie.service';
@Injectable()
export class EcapLoginService {
  isPlatformBrowser: boolean;

  header: any = new HttpHeaders({
    "Content-Type": "application/json"
  });
  notFoundStatus: number = 404;
  commonOptions: any = { headers: this.header, withCredentials: true, observe: 'response' };

  constructor(
    private utilityService: UtilityService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private appProvider: AppProvider,
    private tokenProvider: TokenProvider,
    private navigationProvider: NavigationProvider,
    private http: HttpClient,
    private featureActivator: FeatureCanActivate,
    private featureProvider: FeatureProvider,
    private router: Router,
    private userInfoService: UserInfoService,private readonly _cookieService: EcapCookieService, private clientMonitoringService: ClientMonitoringService) {
    this.isPlatformBrowser = isPlatformBrowser(this.platformId);
  }

  isiOS(): any {
    var iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) { return true; }
      }
    }

    return false;
  }

  logoutFromPlatform(dontNavigateToDefaultRoute?) {
    if (ShellDomainProvider['api'].isSSo) {
      this.internalSSOLogoff();
      this.resetTokenRelatedTask(dontNavigateToDefaultRoute);
    } else if (ShellDomainProvider['api'].IsExternalSSO) {
      this.externalSSOLogoff();
      this.resetTokenRelatedTask(dontNavigateToDefaultRoute);
    } else {
      this.tokenProvider.securityLogout().then((response: any) => {
        this.resetTokenRelatedTask(dontNavigateToDefaultRoute);
      });
    }
  }

  simpleLogOut(){
    this.tokenProvider.securityLogout().then((response: any) => {
      this.resetTokenRelatedTask();
    });
  }

  internalSSOLogoff() {
    const currentDomain = window.location.protocol + '//' + window.location.hostname;
    const landingUri = ShellDomainProvider['api']['logOffLandingUri'] || ShellDomainProvider['api']['landingUri'] || currentDomain;
    const siteUrl = window.location.hostname;
    let ssoDomains = siteUrl;
    let may_access = ShellDomainProvider['api']['ssoDomains'] || localStorage.getItem('may_access');

    //#region //? SSO config with Ignored domain
    const ssoIgnoreDomains = ShellDomainProvider['api']['ssoIgnoreDomains'];
    if (ssoIgnoreDomains && ssoIgnoreDomains.length) {
      let accessDomainList = Array.isArray(may_access) ? may_access : may_access.split(',');
      accessDomainList = accessDomainList.filter((el: string) => !ssoIgnoreDomains.includes(el));
      accessDomainList = accessDomainList.filter((el: string) => siteUrl !== el);
      may_access = accessDomainList.join(',');
    }
    //#endregion

    if (may_access && may_access !== 'undefined' && may_access !== 'null') { ssoDomains += ',' + may_access; }

    let logoutForm = document.createElement('form');
    logoutForm.action = currentDomain + '/auth?LogOff';
    logoutForm.method = 'post';

    const landingInput = document.createElement('input');
    landingInput.type = 'hidden';
    landingInput.name = 'Landing_Uri';
    landingInput.value = landingUri;

    const ssoDomainsInput = document.createElement('input');
    ssoDomainsInput.type = 'hidden';
    ssoDomainsInput.name = 'Logged_Off_SSO_Domains';
    ssoDomainsInput.value = ssoDomains;

    logoutForm.appendChild(landingInput);
    logoutForm.appendChild(ssoDomainsInput);
    document.getElementsByTagName('body')[0].appendChild(logoutForm);
    logoutForm.submit();
  }

  externalSSOLogoff() {
    var landingUrl = ShellDomainProvider['api'].landingUri;
    var logoutForm = document.createElement('form');
    var currentDomain = window.location.protocol + '//' + window.location.hostname;
    var currentDomainWithoutProtocol = window.location.hostname;
    // var mayAccess = tokenStorage.getMayAccess();
    logoutForm.action = currentDomain + '/auth?LogOff';
    logoutForm.method = 'post';
    var landingUrlFinal = landingUrl;
    const landingInput = document.createElement('input');
    landingInput.type = 'hidden';
    landingInput.name = 'Landing_Uri';
    landingInput.value = landingUrl;

    const ssoDomainsInput = document.createElement('input');
    ssoDomainsInput.type = 'hidden';
    ssoDomainsInput.name = 'Logged_Off_SSO_Domains';
    ssoDomainsInput.value = currentDomainWithoutProtocol;

    logoutForm.appendChild(landingInput);
    logoutForm.appendChild(ssoDomainsInput);
    document.getElementsByTagName('body')[0].appendChild(logoutForm);
    logoutForm.submit();
  }

  resetTokenRelatedTask(dontNavigateToDefaultRoute?) {
    this.tokenProvider.getAnnonymousToken().then((response: any) => {
      this.userInfoService.resetUserInfo();
      this.clearExistingRefreshToken();
      this.tokenProvider.setRefreshToken(response.refresh_token);
      this.tokenProvider.setRefreshTokenToCookie(response.refresh_token);
      this.featureProvider.resetFeatures();
      this.appProvider.assignAppsVisibility();
      this.navigationProvider.assignNavigationsVisibility();
      this.navigationProvider.resetLastCancelledNavigation();

      const expectedCookie = this._cookieService.getCookie("ecap-user-roles");
      if (expectedCookie){
        this._cookieService.eraseCookie("ecap-user-roles");
      }
      
      if (this.isiOS) {
        if (this.isPlatformBrowser) {
          localStorage.removeItem('REFRESH_TOKEN');
        } else {
          process.env.ACCESS_TOKEN_FOR_IOS = '';
          process.env.REFRESH_TOKEN_FOR_IOS = '';
        }
      }
      this.clientMonitoringService.clearAuthenticatedUserContext();
      this.userInfoService.changeCurrentUserData('LOG_OUT');
      !dontNavigateToDefaultRoute && this.router.navigate([`/`]);
    });
  }

  clearExistingRefreshToken() {
    const hostname = window.location.hostname;
    document.cookie = `REFRESH_TOKEN=; path=/; max-age=0;`;
    //document.cookie = `REFRESH_TOKEN=; path=/; max-age=0; domain=${hostname};`;
  }

  signupUserFromPersonUsingBusinessSevice(personInfo, serviceApi): any {
    let personPayload = {
      Email: personInfo && personInfo.Email
    }
    return this.http.post(serviceApi, personPayload,
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  // emailExists(email): any {
  //     let params = new HttpParams().append("Email", email);
  //     let options = this.commonOptions;
  //     options['params'] = params;
  //     return this.http.get(
  //         ShellDomainProvider['api'].Security + "Authentication/IsEmailAvaiable",
  //         options
  //     );
  // }

  emailExists(email): any {
    return this.http.post(
      ShellDomainProvider['api'].Security + "Authentication/IsEmailAvaiable",
      { Email: email },
      { headers: this.header, withCredentials: true, observe: 'response' }
    );
  }

  createNewUser(personInfo) {
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/CreateUser', personInfo,
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  activateAccount(password, activationCode, currentCountryCode, currentPhoneNumber) {
    return this.http.post(ShellDomainProvider['api'].Security + 'Authentication/ActivateAccount', { "Password": password, "AccountActivationCode": activationCode, "CountryCode": currentCountryCode, "PhoneNumber": currentPhoneNumber },
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  verifyAccount(activationCode) {
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/VerifyEmail', { "AccountId": activationCode },
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  sendResetPasswordRequest(email, verificationCode) {
    let payload = { Email: email, VerificationCode: verificationCode };
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/RecoverAccount', payload,
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  resetPassword(password, activationCode) {
    let payload = { NewPassword: password, RecoverAccountCode: activationCode };
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/ResetPassword', payload,
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  checkActivationCodeValidation(activationCode) {
    let params = new HttpParams().append("ActivateAccountCode", activationCode);
    let options = this.commonOptions;
    options['params'] = params;
    return this.http.get(
      ShellDomainProvider['api'].Security + "Authentication/ActivateAccountCodeCheck",
      options
    );
  }

  verify2faCode(code, token): Observable<any> {
    let body = new HttpParams().set('grant_type', 'authenticate_two_factor_code').set('two_factor_code', code).set('two_factor_token', token);

    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(ShellDomainProvider['api'].Token, body.toString(), { headers: header, withCredentials: true }).pipe(map((response: any) => {
      this.tokenProvider.setRefreshToken(response.refresh_token);
      this.tokenProvider.setRefreshTokenToCookie(response.refresh_token);
      this.featureActivator.resetFeatures();
      return response;
    }, (error) => {
      // console.log("2FA ERROR FOUND");
      return error;
    }));
  }

  resend2FaCode(token, verificationCode, isUseEmail?): Observable<any> {
    const body = {
      "VerificationCode": verificationCode,
      "TwoFAToken": token,
      "UseEmail": isUseEmail ? true : false
    }
    const header = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(ShellDomainProvider['api'].SecurityIdentity + "Authentication/Resend2FaCode", body, { headers: header, withCredentials: true });
  }

  resend2FaCodeForwhatsapp(token, verificationCode,medium, isUseEmail?): Observable<any> {
    const body = {
      "VerificationCode": verificationCode,
      "TwoFAToken": token,
      "UseEmail": isUseEmail ? true : false,
      "isWhatsAppMedium" : true
    }
    const header = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(ShellDomainProvider['api'].SecurityIdentity + "Authentication/Resend2FaCode", body, { headers: header, withCredentials: true });
  }


  setPasswordLoginLink(linkId, linkCode, password?) {
    linkCode = linkCode || this.utilityService.getNewGuid();
    var data = {
      LinkId: linkId,
      LinkCode: linkCode,
      Password: password
    };
    const header = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(ShellDomainProvider['api'].Security + "Authentication/ActivateLogInLink", data, { headers: header, withCredentials: true }).pipe(map((response: any) => {
      if (response && response['Errors'] && response['Errors'].IsValid) {
        return {
          Response: response,
          LinkCode: linkCode,
          LinkId: linkId
        }
      } else {
        return {
          Response: null,
          LinkCode: linkCode,
          LinkId: linkId
        }
      }
    }));
  }

  requestLoginWithLink(linkId, linkCode, Organization_id?:string,customBody?:any) {
    let body;
    if(!Organization_id){
      body = new HttpParams().set('grant_type', 'authenticate_link_code').set('link_id', linkId).set('link_code', linkCode);
    }else{
      body = new HttpParams().set('grant_type', 'authenticate_link_code').set('link_id', linkId).set('link_code', linkCode).set('Organization_id',Organization_id);
    }
    if(customBody) body = customBody;
    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post(ShellDomainProvider['api'].Token, body.toString(), { headers: header, withCredentials: true }).pipe(map((response: any) => {
      const userRawData = this.userInfoService.geJwtDecodedUserData(response.access_token);
      response['user'] = userRawData;
      this.tokenProvider.setRefreshToken(response.refresh_token);
      this.tokenProvider.setRefreshTokenToCookie(response.refresh_token);
      this.featureActivator.resetFeatures();

      this.clientMonitoringService.setAuthenticatedUserContext(userRawData.UserId, userRawData.UserId);
      return response;
    }, (error) => {
      return error;
    }));
  }

  set_may_access(response: any) {
    return this.tokenProvider.set_may_access(response);
  }

  getSocialLogInUrl({ provider, nextUrl }): Observable<string> {
    const queryString = `?Provider=${provider}&NextUrl=${nextUrl}`;

    return this.http.get(ShellDomainProvider['api'].SecurityIdentity + 'Authentication/GetSocialLogInEndPoint' + queryString,
      { withCredentials: true, responseType: 'text' });
  }

  getAccessCookieForExternalLogin(extCredential: any): Observable<any> {
    let body = extCredential;
    if (typeof extCredential === 'object') {
      body = `grant_type=${extCredential.grant_type}&state=${extCredential.state}&code=${extCredential.code}`;
    }

    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(ShellDomainProvider['api'].Token + '?cacheBuster=' + new Date().getTime(), body, { headers: header, withCredentials: true })
      .pipe(map((response: any) => {
        const userRawData = this.userInfoService.geJwtDecodedUserData(response.access_token);
        response['user'] = userRawData;
        this.tokenProvider.setRefreshToken(response.refresh_token);
        this.tokenProvider.setRefreshTokenToCookie(response.refresh_token);
        this.featureActivator.resetFeatures();
        return response;
      }, (error) => {
        return error;
      }));
  }

  activateLoginLinkWith2FA(payload:ActivateLoginLinkPayload) {
    payload.LinkCode = payload.LinkCode || this.utilityService.getNewGuid();
    const header = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(ShellDomainProvider['api'].Security + "Authentication/ActivateLogInLink", payload, { headers: header, withCredentials: true }).pipe(map((response: any) => {
      if (response && response['Errors'] && response['Errors'].IsValid) {
        return {
          Response: response,
          LinkCode: payload.LinkCode,
          LinkId: payload.LinkId,
          TfaCode:payload && payload.TfaCode ? payload.TfaCode:null,
          TfaActivationId: payload && payload.TfaActivationId ? payload.TfaActivationId:null,
          IsValid: response['Errors'] && response['Errors'].IsValid
        }
      } else {
        return response['Errors'];
      }
    }));
  }

  resetPasswordWith2Fa(payload:ResetPasswordTwoFaPayload) {
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/ResetPassword', payload,
      { headers: this.header, withCredentials: true, observe: 'response' }).pipe(map(res=>{

            return res['body']['Errors'];

      }));
  }

  verify2FaForResetPassword(payload:Verify2FaForResetPasswordPayload){
    return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/Verify2FAForResetPassword', payload,
    { headers: this.header, withCredentials: true, observe: 'response' }).pipe(map(res=>{
          return res['body']['Errors'];
    }));
  }

}
